import React, { useEffect, useState } from "react";
import { AlertBanner } from "../../components";
import { useAppSelector } from "../../store/hooks";
import { selectHasInvalidIp, selectIpStatusInfo } from "../../Assets/common/ipStatusSlice";
import { useParams } from "react-router-dom";
import { RouteWithId } from "../../routes/types";
import { clientManagementApiClient } from "../ClientManagementApiClient";
import { isProposal } from "../models/isProposal";
import { InvestmentProgramRestoreDto } from "../../Assets/models/InvestmentProgram";
import { selectActiveMeeting } from "../Meeting/meetingSlice";
import {MeetingStatus} from "../Meeting/Meeting";

const DEFAULT_IP_STATUS_INFO: InvestmentProgramRestoreDto = {
    ipName: "",
    profileName: null,
    profileOwner: null,
    ipStatus: "",
    restoredProfileName: "",
    wdsGMUrl: ""
};

const InvalidIPBanner = () => {
    const { id } = useParams<RouteWithId>();
    const [proposal, setProposal] = useState(false);
    const hasInvalidIp = useAppSelector(selectHasInvalidIp);
    const ipStatusInfo = useAppSelector(selectIpStatusInfo) ?? DEFAULT_IP_STATUS_INFO;

    const activeMeeting = useAppSelector(selectActiveMeeting);
    const isMeetingOngoing = activeMeeting?.status === MeetingStatus.STARTED || activeMeeting?.status === MeetingStatus.CREATED;

    useEffect(() => {
        clientManagementApiClient.getProfile(id)
            .then(profile => setProposal(isProposal(profile)))
            .catch(error => console.error("Failed to fetch profile:", error));
    }, [id]);

    return (
        <AlertBanner showAlert={(hasInvalidIp && !isMeetingOngoing)} type={"warning"}>
            <div className="invalid-ip-banner-container">
                <div className="invalid-ip-banner-content">
                    <div className="invalid-ip-banner-text">
                        <span className="bold-text">Invalid Investment Program: </span>
                        The {ipStatusInfo.ipName} Investment Program for {ipStatusInfo.profileName} is invalid and will not be displayed in the {proposal ? "proposal" : "profile"}. Please validate the Investment Program in Groupings Management, then manually refresh the holdings via the Asset Summary page.
                    </div>
                    <div className="invalid-ip-banner-link">
                        <p style={{ margin: "0", padding: "0" }}>
                            <a
                                style={{ fontSize: "14px" }}
                                href={ipStatusInfo.wdsGMUrl}
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                View Groupings Management <i className="icon dds-icons marginleft-sm">launch</i>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </AlertBanner>
    );
};

export default InvalidIPBanner;